// Shared Tailwind class constants for case-list/case-form page containers.

export const contentWrapperClasses =
   "relative min-h-[calc(100vh-var(--spacing-nav-height))] bg-surface py-page-gap";

export const caseListContainerClasses = `
    bg-surface p-page-container! rounded-md
    [&_.listing]:bg-surface [&_.listing]:rounded-md
`;
export const caseFormContainerClasses = `
    rounded
    [&_.listing]:bg-surface [&_.listing]:rounded-t
    [&_.listing]:p-2.5 [&_.listing]:mb-10
`;

export const accountCaseFormContainerClasses = `
    bg-surface p-0! rounded
`;

export const caseListContainerWrapperClasses = `
    w-full mx-auto px-0
    min-[576px]:max-w-[540px]
    min-[768px]:max-w-[720px]
    min-[992px]:max-w-[960px]
    min-[1200px]:max-w-[1140px]
    min-[1400px]:max-w-[1320px]
    min-[1500px]:max-w-[1440px]
`;

// Padding lives on caseListContainerClasses; this card is flush inside it.
export const listingCardContentClasses = `
    bg-surface rounded-md
`;

// Tall rows with a flat warm hover; used by tables that share the
// `case-list-table` look (formerly `table.case-list-table` in CSS).
export const caseListTableClasses = `
    [&_tr]:h-14
    [&_thead_tr]:h-11
    [&_tr]:transition-colors
    [&_tr]:duration-200
    [&_tbody_tr:hover>td]:bg-surface-light!
`;

// The design parks a listing's row actions against the table's trailing edge.
export const rowActionCellClasses = "flex justify-end gap-2";

// Row styling for the case list: middle-aligned cells and a flat warm hover.
export const caseListRowClasses = `
    [&_td]:align-middle
    hover:[&_td]:cursor-pointer
    hover:[&_td]:bg-surface-light
`;

// Tbody styling for the case-list table; zero-padding cells, custom font,
// and a hover-reveal of the row "view" button (the `view-btn` class hooks
// into the marker class set by CaseSummaryLink).
export const caseListBodyClasses = `
    border-collapse font-[Open_Sans] font-normal not-italic text-base tracking-normal
    [&_tr]:border-0! [&_tr]:p-0 [&_tr]:m-0
    [&_td]:p-0 [&_td]:m-0
    [&_tr:hover_.view-btn]:opacity-100 [&_tr:hover_.view-btn]:visible
`;

export const caseTableClasses = `
    w-full mb-4 text-content align-top border-border-light text-base overflow-hidden
    [&>:not(caption)>*>*]:p-2
    [&>:not(caption)>*>*]:bg-surface
    [&>:not(caption)>*>*]:border-b
    [&>:not(caption)>*>*]:shadow-[inset_0_0_0_9999px_transparent]
    [&>thead]:align-bottom
    [&_thead]:bg-table-header
    [&_thead]:border-t-table-header
    [&_thead_tr]:text-content!
    [&_thead_th]:bg-table-header!
    [&_td]:text-sm [&_th]:text-sm
    [&_td]:whitespace-normal [&_th]:whitespace-normal
    [&_td]:break-words [&_th]:break-words
    [&_td]:text-left [&_th]:text-left
    [&_tr]:whitespace-normal [&_tr]:break-words
`;